<template>
  <div>
    <v-text-field
      v-if="mask"
      :label="labelValue"
      @input="onInput"
      v-bind="$attrs"
      v-on="$listeners"
      v-mask="{ mask: [...mask], tokens: tokens }"
      :rules="rulesArray"
    ></v-text-field>
  </div>
</template>

<script>
export default {
  name: "FeinField",
  data: () => ({
    mask: null,
    rulesArray: [],
    labelValue: null,
    tokens: {
      "#": { pattern: /\d/ },
      X: { pattern: /[0-9a-zA-Z]/, transform: v => v.toLocaleUpperCase() },
      S: { pattern: /[a-zA-Z]/ },
      A: { pattern: /[a-zA-Z]/, transform: v => v.toLocaleUpperCase() },
      a: { pattern: /[a-zA-Z]/, transform: v => v.toLocaleLowerCase() },
      "!": { escape: true }
    }
  }),
  props: {
    country: Object,
    rules: Array,
    label: String
  },
  methods: {
    onInput(obj) {
      this.$emit("input", obj);
    },
    validate(fein) {
      if (this.country && this.country.organizationTinRegex && !!fein) {
        let regex = RegExp(this.country.organizationTinRegex);
        if (!regex.test(fein)) {
          return "Invalid " + this.labelValue;
        }
      }
      return true;
    },
    resetRulesArray() {
      this.rulesArray = [];
      if (this.rules) {
        this.rulesArray = this.rulesArray.concat(this.rules);
      }
      if (this.country && this.country.organizationTinMask) {
        this.mask = this.country.organizationTinMask;
        this.rulesArray = this.rulesArray.concat(this.validate);
      }
    }
  },
  watch: {
    country: function() {
      if (this.label) {
        this.labelValue = this.label;
      } else {
        if (this.country) {
          this.labelValue = this.country.organizationTinName;
        } else {
          this.labelValue = "FEIN (Select Country First)";
        }
      }
      if (this.country && this.country.organizationTinMask) {
        this.mask = this.country.organizationTinMask;
      }
      this.resetRulesArray();
    }
  },
  mounted() {
    if (this.label) {
      this.labelValue = this.label;
    } else {
      if (this.country) {
        this.labelValue = this.country.organizationTinName;
      } else {
        this.labelValue = "FEIN (Select Country First)";
      }
    }
    this.resetRulesArray();
  }
};
</script>
